import React from "react";
import Round from "./components/Round";
import YouBet from "./components/YouBet";
import LockPrice from "./components/LockPrice";
import Result from "./components/Result";

export default function ResultItem(props: any) {
  const {
    type,
    value,
    isBet,
    betAbove,
    operatorId,
    odds,
    valueBet,
    lockPrice,
    isAbove,
    closePrice,
    lang,
  } = props;
  return (
    <div
      className={`wrap-result-item
    `}
    >
      {type === "round" && <Round value={value} lang={lang}/>}

      {type === "youBet" && (
        <YouBet
          isBet={isBet}
          betAbove={betAbove}
          operatorId={operatorId}
          odds={odds}
          valueBet={valueBet}
          lang={lang}
        />
      )}

      {type === "lockPrice" && <LockPrice lockPrice={lockPrice} lang={lang} />}

      {type === "result" && (
        <Result
          isAbove={isAbove}
          closePrice={closePrice}
          odds={odds}
          operatorId={operatorId}
          lang={lang}
        />
      )}
    </div>
  );
}
